import { createSelector } from 'reselect';
import { RootState } from 'reducers/index';
import { getLastDraftEditDate } from 'cards/util/customization';
import { ProjectListingView } from 'cards/pages/ProductDetail/ProducDetailTypes';

export const getDraftsAndOrdersBusy = (state: RootState) => state.cards.draftsAndOrders.busy;

export const getDraftsAndOrdersWaitingOnPreviewSuites = (state: RootState) =>
  state.cards.draftsAndOrders.waitingOnPreviewSuites;

export const getActiveDraftsTab = (state: RootState) => state.cards.draftsAndOrders.activeDraftsTab;

export const getActiveSegment = (state: RootState) => state.cards.draftsAndOrders.activeSegment;

export const getActiveAnchor = (state: RootState) => state.cards.draftsAndOrders.activeAnchor;

export const getDrafts = (state: RootState) => state.cards.draftsAndOrders.drafts;

export const getAllDrafts = createSelector(getDrafts, drafts => {
  const { PAPER, DIGITAL } = drafts;

  const allDrafts: ProjectListingView[] = [];

  Object.values(PAPER).forEach(paperDrafts => allDrafts.push(...paperDrafts));
  Object.values(DIGITAL).forEach(digitalDrafts => allDrafts.push(...digitalDrafts));

  return allDrafts.sort(
    (a: ProjectListingView, b: ProjectListingView) =>
      // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must...
      getLastDraftEditDate(b) - getLastDraftEditDate(a)
  );
});
export const getPaperDrafts = createSelector(getDrafts, drafts => drafts.PAPER);
export const getDigitalDrafts = createSelector(getDrafts, drafts => drafts.DIGITAL);

export const getOrders = (state: RootState) => state.cards.draftsAndOrders.orders;

export const getPublished = (state: RootState) => state.cards.draftsAndOrders.published;

export const getProjects = (state: RootState) => state.cards.draftsAndOrders.entities.projects;

export const getCustomizations = (state: RootState) =>
  state.cards.draftsAndOrders.entities.customizations;

export const getProofDrafts = (state: RootState) => state.cards.draftsAndOrders.proofDrafts;
export const getProofOrders = (state: RootState) => state.cards.draftsAndOrders.proofOrders;
export const getSamples = (state: RootState) => state.cards.draftsAndOrders.samples;
